export const matchMediaPolifill = (mediaQuery) => {
    // console.warn('`matchMedia` is not supported!');
    return {
        media: mediaQuery,
        matches: false,
        addListener() { },
        removeListener() { },
    };
};
